import * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

export interface Outcome {
  readonly parentId?: ents.core.dms.data.Record.Id
  readonly id: ents.core.dms.data.Record.Id
  readonly name: string
  readonly description: string
  readonly entityId: ents.core.dms.models.Entity.Id
}
export namespace Outcome {
  export const isOutcome = TypeChecker.Factory.object<Outcome>({
    description: TypeChecker.isString,
    entityId: ents.core.dms.models.Entity.Id.isId,
    id: ents.core.dms.data.Record.Id.isId,
    name: TypeChecker.isString,
    parentId: TypeChecker.Factory.optional(ents.core.dms.data.Record.Id.isId),
  })
}
